import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDuDyTmUEy4gY7Yeifs0r2a_yBFNgrf8vg",
  authDomain: "react-firebase-376e4.firebaseapp.com",
  projectId: "react-firebase-376e4",
  storageBucket: "react-firebase-376e4.appspot.com",
  messagingSenderId: "223030603375",
  appId: "1:223030603375:web:795883137b3a587962e79a",
  measurementId: "G-VHQNPWZL9P",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
